// @ts-ignore
import React, {createContext} from "react";
import {Farm} from "../Farms/types";
import {Contract} from 'web3-eth-contract'


export const FarmProvider: React.FC<{ model: Farm, children: any }> = (ev) => {
    return <FarmContext.Provider value={ev.model}>{ev.children}</FarmContext.Provider>
};





export const FarmContext = createContext<Farm>({
    apy: undefined,
    contractAddresses: "",
    sC: undefined,
    earnToken: "",
    earnTokenAddress: "",
    icon: undefined,
    id: "",
    lpContract: undefined,
    lpToken: "",
    lpTokenAddress: "",
    name: "",
    pid: 0,
    tokenBalance: undefined,
    tokenSymbol: "",
    tsl:0,
});


